"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CarouselFallback = function CarouselFallback() {
  return _react["default"].createElement("div", {
    className: "item active",
    style: {
      backgroundColor: _colors.silver,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, _react["default"].createElement(_Icon["default"], {
    name: "picture-3",
    color: _colors.alloy,
    size: "3x"
  }), _react["default"].createElement("p", {
    className: "text-center",
    style: {
      color: _colors.slate,
      marginBottom: 0
    }
  }, "No image available"));
};

var _default = CarouselFallback;
exports["default"] = _default;